import { getApps, initializeApp } from 'firebase/app';
// Optionally import the services that you want to use

const firebaseConfig = {
  apiKey: 'AIzaSyBPeRWnjFhUaK3VlaNZM9GcEmbG7p-RfNk',
  authDomain: 'kippaangog.firebaseapp.com',
  projectId: 'kippaangog',
  storageBucket: 'kippaangog.appspot.com',
  messagingSenderId: '387058368054',
  appId: '1:387058368054:web:fee9607726daf9a7be6297',
  measurementId: 'G-Q8EE9Q1LPC'
};

export const PATHS = {
  app: 'app',
  users: 'users',
  playlists: 'playlists',
  khassida: 'khassida',
  AlQuran: 'Alquran',
  azkaar: 'azkaar',
  contacts: 'contacts',
  contents: 'contents',
  campanges: 'campanges',
  salatous: 'salatous',
  countables: 'countables',
  cotisations: 'cotisations2'
};

export const STORAGE_PATHS = {
  avatars: 'avatars',
  audios: 'audios'
};

if (getApps().length === 0) {
  initializeApp(firebaseConfig);
}
